import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';

import UploadIcon from '@mui/icons-material/CloudUploadOutlined';

import { AvatarTypes } from '../../../components/designe/app-avatar/AppAvatar';
import { AppBarWithButtons } from '../../../components/designe/app-bar-with-action-buttons/AppBarWithButtons';
import { AppBarWithActionButtons } from '../../../components/designe/app-bar-with-buttons/AppBarWithActionButtons';
import AppButton from '../../../components/designe/app-button/AppButton';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../components/designe/app-entity-avatar/AppEntityAvatar';
import AppFormTextField from '../../../components/designe/app-form-text-field';
import AppUploadFileButton from '../../../components/designe/app-upload-file-button/AppUploadFileButton';
import { FormMode } from '../../../shared/constants';
import theme from '../../../styles/theme';
import { uploadFilesUtils } from '../../../utils/upload-files-utils';
import { useStyles } from './UserInfo.styles';
import { useUserInfoComponent } from './useUserInfoComponent';

export default function UserInfo(props) {
  const { t } = useTranslation();
  const { classes } = useStyles(theme);
  const {
    user,
    formik,
    onCancelChanges,
    avatar,
    setAvatar,
    isLoading,
    mode,
    setMode,
  } = useUserInfoComponent();

  return (
    <div className={classes.userInfoWrapper}>
      <form onSubmit={formik.handleSubmit} className={classes.userInfoForm}>
        {mode !== FormMode.edit && (
          <Box className={classes.buttonActionWrapper}>
            <AppBarWithActionButtons
              onEditClick={() => setMode(FormMode.edit)}
            />
          </Box>
        )}
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={classes.avatarWrapper}>
              <AppEntityAvatar
                fileBlob={avatar?.fileBlob}
                entity={user}
                size={AvatarSize.l}
                type={AvatarTypes.square}
              />
            </div>
            {mode === FormMode.edit && (
              <AppUploadFileButton
                variant="outlined"
                label={t('settings.updateAvatar')}
                onFileInput={(e) => {
                  uploadFilesUtils(e.target.files, true).then(
                    (uploadedFiles) => {
                      setAvatar(uploadedFiles[0]);
                    },
                  );
                }}
              />
            )}
          </Grid>
          <Grid item md={mode === FormMode.edit ? 6 : 12} xs={12}>
            <AppFormTextField
              label={t('common.firstname')}
              fullWidth
              name="firstname"
              formik={formik}
              viewMode={mode === FormMode.view}
            />
          </Grid>
          <Grid item md={mode === FormMode.edit ? 6 : 12} xs={12}>
            <AppFormTextField
              label={t('common.lastname')}
              fullWidth
              name="lastname"
              formik={formik}
              viewMode={mode === FormMode.view}
            />
          </Grid>
          <Grid item xs={12}>
            <AppFormTextField
              label={t('common.description')}
              fullWidth
              multiline
              minRows={3}
              maxRows={6}
              name="description"
              formik={formik}
              viewMode={mode === FormMode.view}
            />
          </Grid>
          <Grid item xs={12}>
            {mode === FormMode.edit && (
              <Box className={classes.buttonWrapper}>
                <AppBarWithButtons
                  loading={isLoading}
                  disabled={!formik.dirty && !avatar}
                  onCancelClick={onCancelChanges}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
